import React from "react";
import { Drafted } from "../../../components/article/drafted";

import Layout from "../../../components/layout/layout";

export default function ArticleDrafted({ component, ...rest }) {
  return <Layout Component={Drafted} controlsDisabled={true} {...rest} />;
}
